import {MemberPageState} from '../types/state'

export const getCurrentTab = (state: MemberPageState) => state.tab
